import axios from "axios";
import { toast } from "react-toastify";
const BaseURL = process.env.REACT_APP_API_PATH;

export const getCandidateById = async (id) => {
  try {
    const res = await axios.get(`${BaseURL}/ebench/get_Candidate?id=${id}`);
    return res?.data
  } catch (error) {
    throw new Error(`Failed to fetch admin with ID ${id}`);
  }
};

export const UpdateTeamMember = async (data) => {
  try {
    const res = await axios.put(`${BaseURL}/ebench/update_team_member`, data);
    return res
  } catch (error) {
    console.log("errror of update team api", error?.response?.data?.status?.message)
    toast.error(error?.response?.data?.status?.message)
    return error | "Internal Server Error"
  }
};

export const ActivateCandidate = async (id) => {
  try {
    const response = await axios.put(`${BaseURL}/ebench/activate_candidate_by_admin?candidateId=${id}`);
    toast.success('Candidate activated successfully!');
    return response;
  } catch (error) {
    toast.error(error?.response?.data?.status?.message);
    throw error;
  }
};

export const DeactivateCandidate = async (id) => {
  try {
    const response = await axios.put(`${BaseURL}/ebench/deactivate_candidate_by_admin?candidateId=${id}`);
    toast.success('Candidate deactivated successfully!');
    return response;
  } catch (error) {
    toast.error(error?.response?.data?.status?.message);
    throw error;
  }
};